module.exports = __webpack_public_path__ + "static/media/dead_battery_f1.76a6d393.svg";